import React from 'react';
import _ from 'lodash';

import {
  ReturnAuthorizationsActivity_TabBarDocument,
  useLookUpTier1ReturnAuthorizationByDetailsLazyQuery,
  useReceiveTier1ReturnAuthorizationMutation
} from 'generated/graphql';

import { DateTime } from 'luxon';
import * as types from './types';



export interface IReturnAuthorization {
  id: string;
  returnNumber: string;
  referenceNumber: string;
  inventoryItemSku: string;
  inventoryItemName: string;
  createdTimestamp: DateTime;
}

export interface IData {
  returnAuthorization: IReturnAuthorization | null;
}

export function useLookUpTier1ReturnAuthorizationByDetails() {
  const [fnQuery, tuple] = useLookUpTier1ReturnAuthorizationByDetailsLazyQuery({
    fetchPolicy: 'network-only'
  });

  const fnWrappedQuery = React.useCallback(
    async (formState: types.IFormState) => {

      if (formState.item && formState.store) {
        await fnQuery({
          variables: {
            inState: 'preAlert',
            itemId: formState.item.id,
            storeId: formState.store.id
          }
        });
      }
    },
    [fnQuery]
  );

  const wrappedData = React.useMemo(
    (): IData => {
      const rma = _.first(tuple.data?.tier1ReturnAuthorizations.nodes ?? []);
      return {
        returnAuthorization: rma ? {
          id: rma.id,
          returnNumber: rma.group.referenceNumber,
          referenceNumber: rma.group.referenceNumber,
          inventoryItemSku: rma.item.sku,
          inventoryItemName: rma.item.name,
          createdTimestamp: DateTime.fromISO(rma.createdTimestamp)
        } : null
      };
    },
    [tuple]
  );

  return React.useMemo(
    () => [
      fnWrappedQuery,
      {
        ...tuple,
        data: wrappedData
      }
    ] as const,
    [
      fnWrappedQuery,
      tuple,
      wrappedData
    ]
  );
}



export function useReceiveTier1ReturnAuthorization() {
  const [fnMutate, tuple] = useReceiveTier1ReturnAuthorizationMutation({
    refetchQueries: [
      {
        query: ReturnAuthorizationsActivity_TabBarDocument
      }
    ]
  });

  const fnWrappedMutate = React.useCallback(
    async (formState: types.IFormState, returnAuthorizationId: string) => {
      if (formState.item) {
        await fnMutate({
          variables: {
            input: {
              returnAuthorizationId,
              itemId: formState.item.id,
              serialNumber: formState.serialNumber
            }
          }
        });
      }
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
